export const DOWNLOAD_APP_LINK =
  'https://pheon-ai.onelink.me/bsAj?af_ios_url=https%3A%2F%2Fweb.dialogue.app%2Fauth&af_web_dp=https%3A%2F%2Fweb.dialogue.app%2Fauth&af_xp=custom&pid=web-onboarding&c=campaign-web-onboarding&deep_link_value=userId&deep_link_sub1=auth&af_dp=dialogue%3A%2F%2F';

export const DOWNLOAD_APP_LINK_NO_IOS_FALLBACK =
  'https://pheon-ai.onelink.me/bsAj?af_web_dp=https%3A%2F%2Fweb.dialogue.app%2Fauth&af_xp=custom&pid=web-onboarding&c=campaign-web-onboarding&deep_link_value=userId&deep_link_sub1=auth&af_dp=dialogue%3A%2F%2F';

export const PRIVACY_LINK = 'https://pheon.com/legal/privacy';
export const TERMS_LINK = 'https://pheon.com/legal/terms';
export const PHEON_SUPPORT_EMAIL = 'hello@pheon.com';
export const DIALOGUE_SUPPORT_EMAIL = 'hello@dialogue.app';

// Lure AI specific links
export const LURE_APP_PRIVACY_LINK = 'https://lurechat.app/legal/privacy';
export const LURE_APP_TERMS_LINK = 'https://lurechat.app/legal/terms';
export const LURE_AI_PRIVACY_LINK = 'https://lurechat.ai/legal/privacy';
export const LURE_AI_TERMS_LINK = 'https://lurechat.ai/legal/terms';
export const LURE_AI_SUPPORT_EMAIL = 'support@lurechat.ai';
export const LURE_APP_SUPPORT_EMAIL = 'support@lurechat.app';

export const WEB_APP_URL = import.meta.env.VITE_WEB_APP_URL;
export const LURE_AI_WEB_APP_URL = import.meta.env.VITE_LURE_AI_WEB_APP_URL;
export const LURE_APP_WEB_APP_URL = import.meta.env.VITE_LURE_APP_WEB_APP_URL;

export const PAYMENT_SECTION_ID = 'payment-section';
export const SELECT_PLAN_SECTION_ID = 'select-plan-section';
export const SECOND_SELECT_PLAN_SECTION_ID = 'second-select-plan-section';

export const PAYWALL_TIMER_MINUTES = 10;

export const S3_BUCKET_URL =
  'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets';

export const STRIPE_BUSINESS_ACCOUNT_COUNTRY = 'US';

// CATEGORIES
export const GIRLS_CATEGORY = 'd4dddbb7-78b1-4704-b5d8-c51eebf92d01';
export const WOMEN_CATEGORY = '92d648fa-6f0d-4282-80d5-045f363d1685';
export const BOYS_CATEGORY = '1d7a79ea-1f81-47c1-ad1c-8eed3bd08378';
export const TWINK_CATEGORY = '16416593-1584-4e9b-a409-26d22f814b45';
export const DADDY_CATEGORY = 'acac81bf-0e43-4972-bf8a-dba6a53b8d2d';
export const SPORTY_CATEGORY = '88239be8-18cd-4161-a155-d4f6141c5378';
export const BEAR_CATEGORY = 'fd999860-1c5f-4a58-b66f-1055daee6688';
export const TRANS_CATEGORY = '2c5cb092-2dea-4ab6-b870-f3f956fc904e';
export const COSPLAY_CATEGORY = 'f8e41169-5258-4fb1-b223-75c40f998f33';
export const REAL_PEOPLE_AIS_CATEGORY = '7ffe5dd5-3a4b-42b8-9817-62fce9ab152e';
export const CURVY_CATEGORY = 'cfd50255-6f15-4060-b9ba-2ee4f3cb5a7e';
export const ROLEPLAY_CATEGORY = '93616998-7312-445c-bebc-b06cce7844f1';
export const STRONG_STUNNING_CATEGORY = '51be5603-b2c1-4848-a9ca-fdc9b6c72872';
export const ON_THE_DUTY_CATEGORY = 'b85cb582-6a0f-492e-bb05-a17d69d61c38';
export const POWERFUL_WOMEN_CATEGORY = '86105346-531d-4142-9dab-ffd9ffc118f3';
export const FURRY_CATEGORY = '9ae39135-79f9-4b1f-ab33-fa91f5fd54b8';
export const ANIME_CATEGORY = 'e336e63f-beac-4d2d-b11b-4bbb547ed5e8';
export const STRAIGHT_MAN_CATEGORY = 'cc3cc26e-c932-4a72-97a6-133d3319d0f3';

// INACTIVE CATEGORIES
export const WWE_CATEGORY = '5ae9e409-6a08-4ade-b52d-110d03465b9f';
export const RECENTLY_CREATED_CATEGORY = 'e71e737d-ef13-4ec4-8977-77c1e9a38df9';
export const GAMING_CATEGORY = 'fde7d06f-c9dd-4077-a379-8156349ac155';
export const EXPLORE_MORE_CATEGORY = 'f8c4a003-1daa-40c0-8145-3e6c64d519cd';
export const ASSISTANT_CATEGORY = 'b047726e-55a8-4af7-b1bd-6dcb2554d8d2';
export const LEGENDS_CATEGORY = '418f9a34-7a86-4cfc-96a1-354cd5e49631';
export const SOCIAL_MEDIA_CATEGORY = '4eb73d32-1926-4a27-ae12-34434dc2d295';
export const THINGS_CATEGORY = '2b478526-7d68-454a-86a1-42e18bca51c8';
export const HISTORICAL_CATEGORY = '191f008a-b5a5-4e27-8e67-b37e7dca786f';

// INVISIBLE CATEGORIES
export const FEET_CATEGORY = 'eb275d5e-4188-431e-a5cd-1375709f90ae';
